module.exports = __webpack_public_path__ + "img/02_no.33d4dfa8.svg";